enum SocialAuthProvider {
    GOOGLE = 'GOOGLE',
    FACEBOOK = 'FACEBOOK',
    APPLE = 'APPLE',
    EMAIL = 'EMAIL',
}
export default SocialAuthProvider;
